// SERVER CONSTANTS
// TODO(mmd): these should not be set as hard constants -- start local vs. start prod should delineate!

export const SERVER_ADDRESS = process.env.API_URL;
console.log(SERVER_ADDRESS)

export const LOCAL_PORT = 3000;

// TUTORIAL CONSTANTS

export const TUTORIAL_SLIDES_LINK = "https://docs.google.com/presentation/d/1b6O5E657zOmOLw5h9oZKyYPJdMmlACwp5cZg9VluaH4/edit?usp=sharing";
export const TUTORIAL_LENGTH = 4;


// Enables dynamic popup suggestions based on user's previous annotations
export const DYNAMIC_SUGGESTIONS_ENABLED = true;
